var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.167c0 4.667-6 8.667-6 8.667s-6-4-6-8.667a6 6 0 1112 0z",
    stroke: "#476FF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.167a2 2 0 100-4 2 2 0 000 4z",
    stroke: "#476FF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDcuMTY2ODFDMTMgMTEuODMzNSA3IDE1LjgzMzUgNyAxNS44MzM1QzcgMTUuODMzNSAxIDExLjgzMzUgMSA3LjE2NjgxQzEgNS41NzU1MSAxLjYzMjE0IDQuMDQ5MzkgMi43NTczNiAyLjkyNDE3QzMuODgyNTggMS43OTg5NSA1LjQwODcgMS4xNjY4MSA3IDEuMTY2ODFDOC41OTEzIDEuMTY2ODEgMTAuMTE3NCAxLjc5ODk1IDExLjI0MjYgMi45MjQxN0MxMi4zNjc5IDQuMDQ5MzkgMTMgNS41NzU1MSAxMyA3LjE2NjgxWiIgc3Ryb2tlPSIjNDc2RkYyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcgOS4xNjY4MUM4LjEwNDU3IDkuMTY2ODEgOSA4LjI3MTM4IDkgNy4xNjY4MUM5IDYuMDYyMjQgOC4xMDQ1NyA1LjE2NjgxIDcgNS4xNjY4MUM1Ljg5NTQzIDUuMTY2ODEgNSA2LjA2MjI0IDUgNy4xNjY4MUM1IDguMjcxMzggNS44OTU0MyA5LjE2NjgxIDcgOS4xNjY4MVoiIHN0cm9rZT0iIzQ3NkZGMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgLocation as ReactComponent };